import * as React from 'react';
import classnames from 'classnames';
import { Text, Stack } from '@servicetitan/design-system';
import styles from './empty-signature-page.less';

export const EmptySignaturePage: React.FC = () => (
    <Stack direction="column" className={classnames(styles.container, 'p-x-2')}>
        <div className={styles.imageContainer}>
            <img src="/assets/images/signature-empty-page.png" className={styles.image} />
        </div>
        <Text el="span" size="6" bold className="m-t-3">
            Welcome to your <span className={styles.noWrap}>Visit Assistant</span>
        </Text>
        <Text el="span" size="2" bold className="m-t-3">
            Thank you for going contactless.
        </Text>
        <Text el="span" size="2" className="m-t-2">
            When ready, your technician will send over documents and links for you to view and sign
            here.
        </Text>
    </Stack>
);
